/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // Breakpoint
        window.bp = new Breakpoint();

        window.cache = {
          $window: $(window),
          $document: $(document),
          $body: $('body'),
        };


        // Modernizr example
        if (!Modernizr.touchevents) {
          console.log('notouch');
        } else {
          console.log('touch');
        }

        //---------
        // Header
        //---------
        var $header = $('[data-module="header"]');
        if ($header.length > 0) {
          new Header({
            $el: $header
          });
        }

        //---------
        // Custom Select
        //---------
        $('.js-select2').select2({
            width: 'style',
            minimumResultsForSearch: -1
        });

        //---------
        // Location Filter
        //---------
        var $locationFilter = $('[data-module="location-filter"]');
        if ($locationFilter.length > 0) {
          new LocationFilter({
            $el: $locationFilter
          });
        }

        //------------
        // Location Result Map
        //-------------

        // Style map
        var stylemap = [{
          "featureType": "administrative",
          "elementType": "labels.text.fill",
          "stylers": [{"color": "#444444"}]
        }, {"featureType": "landscape", "elementType": "all", "stylers": [{"color": "#f2f2f2"}]}, {
          "featureType": "poi",
          "elementType": "all",
          "stylers": [{"visibility": "off"}]
        }, {
          "featureType": "road",
          "elementType": "all",
          "stylers": [{"saturation": -100}, {"lightness": 45}]
        }, {
          "featureType": "road.highway",
          "elementType": "all",
          "stylers": [{"visibility": "simplified"}]
        }, {
          "featureType": "road.arterial",
          "elementType": "labels.icon",
          "stylers": [{"visibility": "off"}]
        }, {"featureType": "transit", "elementType": "all", "stylers": [{"visibility": "off"}]}, {
          "featureType": "water",
          "elementType": "all",
          "stylers": [{"color": "#c0e4f3"}, {"visibility": "on"}]
        }];

        var $resultMap = $('[data-module="result-map"]');
        if ($resultMap.length > 0) {

          new GoogleMap({
            id: 'result-map',
            title : 'Trustcan',
            zoom: 13,
            styles: stylemap,
            infoWindow: {
              pixelOffset: { x: 0, y: 0 },
            },
            icon: {
              url: $resultMap.attr('data-icon'),
              width: 31,
              height: 45,
            },
            markers: [
              {
                lat: $resultMap.attr('data-latitude'),
                lng: $resultMap.attr('data-longitude'),
              }
            ]
          });

        }

        //---------
        // Price
        //---------
        var $price = $('.js-price-slider');
        if ($price.length > 0) {
          new Price({
            $el: $price
          });
        }

        //---------
        // Contact page
        //---------
        var $contact = $('[data-module="contact"]');
        if ($contact.length > 0) {
          new Contact({
            $el: $contact
          });
        }

        //Envoi mail par ajax
        $("#formMail").submit(function(e){
            e.preventDefault();
            $("#formMail .txtMessage").hide();

            var error = 0;
            $("#formMail [data-required]").each(function(){
                $(this).removeClass("data-required");
                if($(this).val() === ""){
                    $("#txtFormError").slideDown(300);
                    $(this).addClass("data-required");
                    // Display error fields
                    $('<span role="alert" class="wpcf7-not-valid-tip">Champ obligatoire</span>').insertAfter($(this));
                    error=1;
                }
            });

            //Si pas erreur,  on envoi
            if(error === 0){
                var sData = $(this).serialize();
                $.ajax({
                  method: "POST",
                  url: ajaxurl,
                 // dataType : "json",
                  data:  sData
                })
                .done(function( data ) {
                    if(data === "1"){
                        $("#txtFormSent").slideDown(300);
                        $("#formMail [data-required]").val("");
                        var curUrl = window.location.href;
                        ga('send', 'event', 'Formulaire', 'Envoi', curUrl);
                        dataLayer.push({
                            'event': 'gaEvent',
                            'eventCategory': 'Formulaire',
                            'eventAction': 'Envoi',
                            'eventLabel': curUrl
                        });
                        console.log(curUrl);

                    }
                });
            }
        });           

        //Date time Picker
        jQuery('#datetimepicker').datetimepicker();

        //---------
        // Slider
        //---------
        var $slider = $('.js-slider');
        if ($slider.length > 0) {
          new Slider({
            $el: $slider
          });
        }

        //---------
        // Service
        //---------
        var $service = $('[data-module="service"]');
        if ($service.length > 0) {
          new Service({
            $el: $service
          });
        }

        //---------
        // Block Link
        //---------
        var $blocklink = $('.js-blockLink');
        if ($blocklink.length > 0) {
          new Blocklink({
            $el: $blocklink
          });
        }

        //---------
        // Block Link
        //---------
        var $productList = $('[data-module="product-list"]');
        if ($productList.length > 0) {
          new ProductList({
            $el: $productList
          });
        }



        //------------
        // Contact Map
        //-------------
        var $map = $('#contact-map');
        if ($map.length > 0) {
          new GoogleMap({
            id: 'contact-map',
            title : 'Trustcan',
            styles: stylemap,
            infoWindow: {
              pixelOffset: { x: 0, y: 0 },
            },
            icon: {
              url: $map.attr('data-icon'),
              width: 31,
              height: 45,
            },
            zoom: 14,
            markers: [
                {
                    lat: $map.attr('data-latitude'),
                    lng: $map.attr('data-longitude'),
                }
            ]
          });
        }
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
